<template>
    <div v-if="episode" class="w-full">
        <PageHeader type="Episode" :title="episode.title" :image="episode.image ?? episode.podcast.image">
            <template #meta>
                <Link :href="'/podcast/' + episode.podcast_id" class="font-semibold text-white hover:underline">{{ episode.podcast.title }}</Link>
                <template v-if="episode.ordering"><span class="mx-1">·</span>#{{ episode.ordering }}</template>
                <template v-if="episode.source && episode.source[0] && episode.source[0].length"><span class="mx-1">·</span>{{ episode.source[0].length }}</template>
            </template>
            <template #actions>
                <button @click="prepareCurrent({ id: episode.id, type: 'EPISODE', title: episode.title || episode.name })"
                    class="nl-play-fab h-14 w-14 text-xl" aria-label="Play episode">
                    <span class="icon-play translate-x-0.5"></span>
                </button>
            </template>
        </PageHeader>

        <section class="max-w-3xl">
            <h2 class="nl-section-title mb-3">Episode description</h2>
            <div class="nl-prose text-nomad-300" v-html="episode.description"></div>
        </section>

        <AdSlot placement="listFeed" class="mt-10" />
    </div>
</template>
<script setup>
import PageHeader from "@/components/ui/PageHeader.vue";
defineProps({ episode: Object });
</script>
<script>
import AdSlot from "@/components/ui/AdSlot.vue";
import { Link, usePage } from "@inertiajs/vue3";
import { defineAsyncComponent } from 'vue'
import { mapState, mapActions } from "vuex";
import EpisodeCard from "@/components/EpisodeCard.vue";
export default {
    methods: {
        ...mapActions("current", ["prepareCurrent"]),
        formatDuration(seconds) {
            if (!seconds) return '';
            const hours = Math.floor(seconds / 3600);
            const minutes = Math.floor((seconds % 3600) / 60);
            if (hours > 0) {
                return `${hours}h ${minutes}m`;
            }
            return `${minutes}m`;
        }
    },
    beforeMount() {
        document.title = this.episode.title
    },
    components: {
        AdSlot,
        Link,
        EpisodeCard,
    }
};
</script>
